module.exports = __webpack_public_path__ + "img/bus.be4707c4.svg";